import {
  AutoUpdateGarpRequest,
  AutoUpdateGarpResponse,
  garpApi,
} from '@texas/api/endpoints/erp/garpApi';
import { materialsApi } from '@texas/api/endpoints/metadata/materialsApi';
import { useApiResource } from '@texas/api/hooks/useApiResource';
import { useAutoUpdateForm } from '@texas/components/shared/autoUpdate/useAutoUpdateForm';
import { useEffect } from 'react';

export const useGarpStandardForm = ({
  variantId,
  branchId,
  defaultValues,
}: {
  variantId: number;
  branchId: number;
  defaultValues: AutoUpdateGarpRequest;
}) => {
  const {
    register,
    registerAutoUpdate,
    triggerSubmit,
    form,
    control,
    watch,
    setValue,
    formState,
  } = useAutoUpdateForm<AutoUpdateGarpRequest, AutoUpdateGarpResponse>({
    autoUpdateRequest: garpApi.autoUpdateGarp,
    requestParams: [variantId, branchId],
    namePrefix: 'garp',
    defaultValue: defaultValues,
  });

  const {
    data: materials,
    loading: materialsLoading,
    refetch,
  } = useApiResource(materialsApi.getAll);

  useEffect(() => {
    refetch();
  }, [refetch]);

  return {
    register,
    registerAutoUpdate,
    triggerSubmit,
    form,
    control,
    watch,
    formState,
    setValue,
    metadata: {
      materials,
      materialsLoading,
    },
  };
};
